import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Permision } from '../../../core/models/permision.interface';
import { Profile } from '../../../core/models/users.interface';
import { dualListSettings } from '../../../../main';
import { GroupService } from '../../../core/services/group/group';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { MatIcon } from '@angular/material/icon';
import { LoadingService } from '../../../core/services/loading/loading';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-permisions-assign',
  imports: [AngularDualListBoxModule, MatIcon],
  templateUrl: './permisions-assign.html',
  styleUrl: './permisions-assign.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermisionsAssign {
  permisions: Permision[] = [];
  profile: Profile | null = null;
  firtsReder = true;
  selected: Permision[] = [];
  format = dualListSettings;
  errorMsg: string[] | null = null;

  constructor(
    private groupService: GroupService,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<PermisionsAssign>,
    private loadingService: LoadingService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) data: { profile: Profile },
  ) {
    this.profile = data.profile;
  }

  ngOnInit(): void {
    if (this.profile) {
      this.selected = [...this.profile.permisions];
    }
    this.fetchPermisions();
  }

  private fetchPermisions() {
    if (this.profile) {
      this.groupService.getAllPermisions(true).subscribe((permisions) => {
        this.permisions = [...permisions];
        this.cdr.markForCheck();
      });
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveChanges() {
    if (!this.profile) return;

    this.loadingService.show(true);
    this.groupService.assignUserPermision(this.selected, this.profile).subscribe({
      next: () => {
        this.loadingService.show(false);
        this.toastr.success('Permisos asignados correctamente', 'Exitoso');
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loadingService.show(false);
        this.toastr.error(
          'Error: ' + (err.error?.error ?? err.error?.detail ?? err.message),
          undefined,
          {
            progressBar: true,
            timeOut: 5000,
          },
        );
      },
    });
  }
}
